import React from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { fromStore } from '../../../selectors';
import cn from 'classnames';
import { useDispatch } from 'react-redux';
import { deleteIps, updateIps } from '../../../action';
import swal from 'sweetalert';

export const ItemRow = ({ item }) => {
    const dispatch = useDispatch();
    const loaderUpdateIp = useSelector(fromStore.loaderUpdateIpsSelector);
    const loaderDeleteIp = useSelector(fromStore.loaderDeleteIpsSelector);
    const loaderUpdate = loaderUpdateIp === item.id;
    const loadertDelete = loaderDeleteIp === item.id;

    const onToogleActiveIp = () => {
        const data = { enabled: !item.enabled };
        dispatch(updateIps(item.id, data))
    };

    const onDeleteIp = () => {
        swal({
            title: `Удаление IP`,
            text: `Вы действительно хотите удалить IP ${item.ip}?`,
            icon: "warning",
            dangerMode: true,
            buttons: ["Отмена", "Удалить"],
        }).then((willDelete) => {
            if (willDelete) {
                dispatch(deleteIps(item.id));
            }
        });
    }

    const renderBodyMobile = () => {
        return(
            <div className='mobile_div_flex column padding10px'>                
                <div className='mobile_div_flex'>
                    <div style={{ width: '50%' }}>
                        IP:
                    </div>
                    <div style={{ width: '50%', color: '#000' }}>
                        {item.ip}
                    </div>
                </div>
                <div className='mobile_div_flex'>
                    <div style={{ width: '50%' }}>
                        Дата:
                    </div>
                    <div style={{ width: '50%', color: '#000' }}>
                        {moment(item.created_at).format('DD.MM.YYYY HH:mm')}
                    </div>
                </div>
                <div className='mobile_div_flex'>
                    <div style={{ width: '50%' }}>
                        Инициатор:
                    </div>
                    <div style={{ width: '50%', color: '#000' }}>
                        {item.phone}
                    </div>
                </div>
                <div className='mobile_div_flex' style={{ width: 'calc(50% + 80px)', justifyContent: 'flex-end'}}>
                    <button
                        onClick={onToogleActiveIp}
                        style={{ marginRight: '3px' }}
                        data-tip={item.enabled ? 'Выключить' : 'Включить'}
                        disabled={loaderUpdate || loadertDelete}
                        className={cn("btn btn-sm btn-icon btn-icon-md", {
                            'btn-danger': !item.enabled,
                            'btn-success': item.enabled,
                            'kt-spinner kt-spinner--center kt-spinner--sm kt-spinner--light': loaderUpdate
                        })}>
                        {!loaderUpdate && <i className="la la-power-off"></i>}
                    </button>
                    <button
                        onClick={onDeleteIp}
                        disabled={loaderUpdate || loadertDelete}
                        data-tip="Удалить" 
                        className={cn("btn btn-sm btn-clean btn-icon btn-icon-md", {
                            'kt-spinner kt-spinner--center kt-spinner--sm kt-spinner--danger': loadertDelete
                        })}>
                            {!loadertDelete && <i className="la la-trash"></i>}
                    </button>
                </div>
            </div>
        );
    }

    if(window.innerWidth < 550)
        return(
            <tr key={`${item.id}_ip`} className="kt-datatable__row">
                {renderBodyMobile()}
            </tr>
        );

    return (
        <tr key={`${item.id}_ip`} className="kt-datatable__row">
            <td className="kt-datatable__cell" style={{ width: '150px' }}><span>{item.ip}</span></td>
            <td className="kt-datatable__cell" style={{ width: '150px' }}>
                {moment(item.created_at).format('DD.MM.YYYY HH:mm')}
            </td>
            <td className="kt-datatable__cell" style={{ width: 'auto' }}><span>{item.phone}</span></td>
            <td align='right' width="120px" className="kt-datatable__cell">
                <button
                    onClick={onToogleActiveIp}
                    style={{ marginRight: '3px' }}
                    data-tip={item.enabled ? 'Выключить' : 'Включить'}
                    disabled={loaderUpdate || loadertDelete}
                    className={cn("btn btn-sm btn-icon btn-icon-md", {
                        'btn-danger': !item.enabled,
                        'btn-success': item.enabled,
                        'kt-spinner kt-spinner--center kt-spinner--sm kt-spinner--light': loaderUpdate
                    })}>
                    {!loaderUpdate && <i className="la la-power-off"></i>}
                </button>
                <button
                    onClick={onDeleteIp}
                    disabled={loaderUpdate || loadertDelete}
                    data-tip="Удалить" 
                    className={cn("btn btn-sm btn-clean btn-icon btn-icon-md", {
                        'kt-spinner kt-spinner--center kt-spinner--sm kt-spinner--danger': loadertDelete
                    })}>
                        {!loadertDelete && <i className="la la-trash"></i>}
                </button>
            </td>
        </tr>
    );
}
